module.exports = __webpack_public_path__ + "static/carbon-f965c233af3a58de27c3fd7a338ba56f.webm";